import React, { FC, useState, useEffect } from "react"
import _ from "lodash"
import { RouteComponentProps } from "@reach/router"
import Subnav from "components/subnav"
import { Container_s, Content_s } from "styles/app-styles"
import toggles from "feature-toggles"

const Multifamily: FC<RouteComponentProps> = (props) => {
  const [tabs, setTabs] = useState<Array<{name: string, link: string}> | []>([])

  useEffect(() => {
    let tab_list = [
      {name: "Rent Roll", link: "/n/multifamily/rent-roll", hard: false},
      {name: "Inflation", link: "/n/multifamily/inflation", hard: false},
      {name: "Area Measures", link: "/n/multifamily/area-measure", hard: false}
    ]

    if(toggles.displayNewMFLineItems()) {
      tab_list.splice(1, 0, {
        name: "Line Items",
        link: "/n/multifamily/line-items",
        hard: false
      })
    } else {
      tab_list.splice(1, 0, {
        name: "Line Items",
        link: "/multifamily/line-items",
        hard: true
      })
    }

    setTabs(tab_list)
  }, [])

  return (
    <Container_s>
      <Subnav section="MULTIFAMILY" tabs={tabs}/>
      <Content_s>
        { props.children }
      </Content_s>
    </Container_s>
  )
}

export default Multifamily
